import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import LinearProgress from '@material-ui/core/LinearProgress'
import { PageHeader } from 'components/page-header'
import { useStudentInsightsSummary } from 'components/student-insights/api-hooks'
import {
  flags,
  useFeatureFlags,
  useFeatureFlagsLoading,
} from 'lib/feature-flags'
import { useAuth } from 'lib/auth'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'
import NeedsAttentionCard from './needs-attention-card'
import AutomationsLinkCard from './automations-link-card'

export const NEEDS_ATTENTION_LIMIT = 25
const STUDENTS_LIST_PATH = '/pga-coach/students/list'

const FollowUps = () => {
  const settingsClasses = useSettingsStyles()
  const { user } = useAuth()
  const { data, loading, error } = useStudentInsightsSummary(
    NEEDS_ATTENTION_LIMIT,
  )
  const summary = data?.studentInsightsSummary

  useEffect(() => {
    if (error) {
      window.rg4js &&
        window.rg4js('send', { error, tags: ['student-insights'] })
    }
  }, [error])

  return (
    <>
      <PageHeader
        title="Follow-ups"
        subtitle="Reach students at the moments they are most likely to drop off, while keeping every message under your control."
        backTo={STUDENTS_LIST_PATH}
      />
      <Box className={settingsClasses.contentContainer}>
        <NeedsAttentionCard
          insights={summary?.needsAttention || []}
          totalCount={summary?.needsAttentionCount || 0}
          loading={loading && !data}
          error={Boolean(error) && !summary}
          canMessage={!user?.hideSensitiveInformation}
        />
        <AutomationsLinkCard />
      </Box>
    </>
  )
}

const FollowUpsPage = () => {
  const [isStudentInsightsEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_STUDENT_INSIGHTS,
  ])

  const flagsLoading = useFeatureFlagsLoading()

  if (!isStudentInsightsEnabled) {
    if (flagsLoading) return <LinearProgress color="primary" />
    return <Redirect to={STUDENTS_LIST_PATH} />
  }

  return <FollowUps />
}

export default FollowUpsPage
